import { ValidatorFn, Validators } from '@angular/forms';

export function FirstNameValidator(): ValidatorFn {
  return Validators.pattern('^[A-ZŻŹĆĄŚĘŁÓŃÄÖÜ]{1}[a-zzżźćńółęąśäöüß]+((\\s|-)[A-ZŻŹĆĄŚĘŁÓŃÄÖÜ]{1}[a-zzżźćńółęąśäöüß]+)?$');
}

export function SimplifiedFirstNameValidator(): ValidatorFn {
  return Validators.pattern('^[^0-9@#$%]+$');
}